
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import SingleCourse from './SingleCourse.vue'
import CoursesContent from './CoursesContent.vue'
import WenFang from './WenFang.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'

@Observer
@Component({
  components: {
    LazyImg,
    SingleCourse,
    CoursesContent,
    WenFang
  }
})
export default class Process extends Vue {
  @Prop({ required: true }) readonly dataSource!: CalligraphyLevel2JsonResp

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
